<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">

			<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
				<!--begin: Search Form -->
				<div class="m-form m-form--label-align-right">

				</div>
				<div style="clear: both;"></div>
				<div class="m--margin-top-10 m--margin-bottom-10"
					style="width: 100%;text-align: center;float: initial;">
				</div>
				<!--end: Search Form -->
				<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
					<!--begin: Datatable -->
					<el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
						<el-table-column prop="stuName" label="姓名" width="120">
						</el-table-column>
						<el-table-column prop="stuNo" label="工号" width="120">
						</el-table-column>
						<el-table-column prop="cpSecName" label="科室" width="200">
						</el-table-column>
						<el-table-column prop="delayMonth" label="延期月份" width="200">
						</el-table-column>
						<el-table-column prop="reason" label="延期原因">
						</el-table-column>
						<el-table-column label="状态" width="120">
							<template slot-scope="scope">
								<span v-show="scope.row.dataStatus==0" style="color: #666;">审核中</span>
								<span v-show="scope.row.dataStatus==1" style="color: green;">审核通过</span>
								<span v-show="scope.row.dataStatus==2" style="color: red;">审核不通过</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="Score(scope.row)" type="text" size="medium"
									v-show="scope.row.dataStatus==1 && (scope.row.CPIDScore==0)">评分<!--如果不能评分，说明没有评分数据，CPIID是null-->
								</el-button>
								<span v-show="scope.row.dataStatus==1 && scope.row.CPIDScore>0">已补评分</span>
								<el-button @click="ReSave(scope.row)" type="text" size="medium"
									v-show="scope.row.dataStatus==2">重新提交
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!--end: Datatable -->
					<div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]"
							:page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="condition.recordCount">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="重置延期考评" :visible.sync="dialogDelayVisible" width="500px">
			<el-form :model="form">
				<el-form-item label="姓名" label-width="120px">
					<el-input v-model="form.delay.stuName" autocomplete="off" readonly></el-input>
				</el-form-item>
				<el-form-item label="工号" label-width="120px">
					<el-input v-model="form.delay.stuNo" autocomplete="off" readonly></el-input>
				</el-form-item>
				<el-form-item label="延期月份" label-width="120px">
					<el-input v-model="form.delay.delayMonth" autocomplete="off" readonly></el-input>
				</el-form-item>
				<el-form-item label="延期理由" label-width="120px">
					<el-input v-model="form.delay.reason" autocomplete="off" type="textarea" :rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogDelayVisible = false">取 消</el-button>
				<el-button type="primary" @click="delaySave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'DelayEvaluationList',
		data() {
			return {
				condition: {
					token: '',
					currentPage: 1,
					pageSize: 10
				},
				secOptions: [],
				managesecOptions: [],
				tableData: null,
				searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/DelayEvaluationList',
				loading: true,
				dialogDelayVisible:false,
				form: {
					delay: {
						token: '',
						id:'',
						cpid: '', //轮转明细编号
						cpSec: '', //管理单元编号
						cpSecName: '', //管理单元名称
						stuid: '', //学生编号
						stuName: '', //学生姓名
						stuNo: '', //学生工号
						reason: '', //理由
						delayMonth: '', //延期日期
						dataStatus: 0 ,//状态
						addTime:''
					}
				}
			}
		},
		methods: {
			// 调整每页显示数
			handleCurrentChange: function(val) {
				this.condition.firstSearch = false
				this.condition.currentPage = val
				this.$refs.btnSearch.Search()
			},
			// 分页操作
			handleSizeChange: function(val) {
				this.condition.firstSearch = false
				this.condition.pageSize = val
				this.condition.currentPage = 1
				this.$refs.btnSearch.Search()
			},
			//加载延期列表
			loadDelayList: function() {
				var loaddata = {
					token: sessionStorage.getItem('token')
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/DelayEvaluationList', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							this.tableData = res.data.Data
							console.log(this.tableData)
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.loading = false
					})
					.catch(err => {
						this.tableData = null
						console.log(err)
						this.$message({
							message: '查询失败',
							type: 'error'
						})
						this.loading = false
					})
			},
			Score: function(row) {
				if(row.CPIID==null){
					this.$message({
						message: '无法评分',
						type: 'error'
					})
					return
				}
				
				this.$router.push({
					name: 'StuScoreEditDelay',
					params: {
						id: row.CPIID
					}
				})
			},
			ReSave:function(row){
				this.form.delay.id = row.id
				this.form.delay.cpid = row.cpid
				this.form.delay.cpSec = row.cpSec
				this.form.delay.cpSecName = row.cpSecName
				this.form.delay.stuid = row.stuid
				this.form.delay.stuName = row.stuName
				this.form.delay.stuNo = row.stuNo
				this.form.delay.reason = row.reason
				this.form.delay.delayMonth = row.delayMonth
				this.form.delay.addTime = row.addTime.replace('T',' ')
				// this.form.delay.dataStatus = row.dataStatus
				this.dialogDelayVisible=true
				
			},
			//保存延期数据
			delaySave: function() {
				var that = this
				if (that.form.delay.reason == '') {
					that.$message({
						message: '延期理由不能为空',
						type: 'error'
					})
					return
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/UpdateDelayEvaluation', this.form.delay)
					.then(res => {
						if (res.data.Code === 0) {
							//重新加载列表
							that.loadDelayList()
							that.dialogDelayVisible = false
							that.$message({
								message: '保存成功',
								type: 'success'
							})
						} else {
							that.$message({
								message: res.data.Msg + '，' + res.data.Data,
								type: 'error'
							})
						}
						that.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						that.$message({
							message: '保存失败',
							type: 'error'
						})
						that.fullscreenLoading = false
					})
			},

		},
		mounted: function() {
			this.condition.token = sessionStorage.getItem('token')
			this.form.delay.token = sessionStorage.getItem('token')
			this.loadDelayList()
		}
	}
</script>

<style scoped="scoped">
	.message-box {
		width: 600px;
	}

	/deep/.el-table .cell {
		line-height: 25px;
	}
</style>
